import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import styles from './S06.module.scss';
import Carousel from '../../../components/product/Carousel';

const cx = classNames.bind(styles);

const S06 = () => {
  const slides = [
    {
      title: '전원분리',
      image: require('../../../assets/images/products/barrel/s06/img01.jpg'),
    },
    {
      title: '상판분리',
      image: require('../../../assets/images/products/barrel/s06/img02.jpg'),
    },
    {
      title: '저수조 물 제거',
      image: require('../../../assets/images/products/barrel/s06/img03.jpg'),
    },
    {
      title: '온수제거',
      image: require('../../../assets/images/products/barrel/s06/img04.jpg'),
    },
    {
      title: '꼭지분리',
      image: require('../../../assets/images/products/barrel/s06/img05.jpg'),
    },
    {
      title: '물받이 분리',
      image: require('../../../assets/images/products/barrel/s06/img06.jpg'),
    },
    {
      title: '저수조 스팀세척',
      image: require('../../../assets/images/products/barrel/s06/img07.jpg'),
    },
    {
      title: '온/냉수 배관 스팀세척 1',
      image: require('../../../assets/images/products/barrel/s06/img08.jpg'),
    },
    {
      title: '온/냉수 배관 스팀세척 2',
      image: require('../../../assets/images/products/barrel/s06/img09.jpg'),
    },
    {
      title: '본체 외관 스팀세척',
      image: require('../../../assets/images/products/barrel/s06/img10.jpg'),
    },
    {
      title: '상판세척',
      image: require('../../../assets/images/products/barrel/s06/img11.jpg'),
    },
    {
      title: '꼭지세척',
      image: require('../../../assets/images/products/barrel/s06/img12.jpg'),
    },
    {
      title: '물받이 세척',
      image: require('../../../assets/images/products/barrel/s06/img13.jpg'),
    },
    {
      title: '이상유무 확인',
      image: require('../../../assets/images/products/barrel/s06/img14.jpg'),
    },
  ];
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <p className={cx('sub')}>20분만에 스팀으로 깨끗하게!</p>
        <h2 className={cx('title')}>믿고 맡기는 풀무원샘물 냉온수기 스팀 세척</h2>
        <p className={cx('text')}>
          냉온수기와 생수 전문교육을 받은 전문가가 방문하여 세척을 해드립니다.
          <br />
          (제주, 도서산간 지역 제외)
        </p>
        <Link className={cx('linkBtn')} to="/고객센터/문의하기">
          냉온수기 세척 온라인 신청
        </Link>
        <Carousel slides={slides} section={1} slidesPerView={5} />
      </div>
    </div>
  );
};

export default S06;
